import { render } from "./RICategories.vue?vue&type=template&id=01b78e5a&scoped=true"
import script from "./RICategories.vue?vue&type=script&lang=js"
export * from "./RICategories.vue?vue&type=script&lang=js"

import "./RICategories.vue?vue&type=style&index=0&id=01b78e5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b78e5a"]])

export default __exports__